import {
  APPLIANCES_FETCH_STARTED,
  APPLIANCES_FETCH_SUCCEEDED,
  APPLIANCES_FETCH_FAILED
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();

export const fetchAppliances = warehouseIds => async dispatch => {
  try {
    abortController.abort();
    const params = new URLSearchParams();

    if (warehouseIds) {
      params.set('warehouse', warehouseIds);
    }

    const appliancesUrl = webPortalApi.buildApiUrl(`warehouse/appliance?${params.toString()}`);
    dispatch({
      type: APPLIANCES_FETCH_STARTED
    });
    abortController = new AbortController();
    const { signal } = abortController;
    const res = await fetch(appliancesUrl, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }
    const appliances = await res.json();

    dispatch({
      type: APPLIANCES_FETCH_SUCCEEDED,
      payload: appliances
    });

    return appliances;
  } catch (e) {
    if (e.name === 'AbortError') {
      return null;
    }
    return dispatch({
      type: APPLIANCES_FETCH_FAILED,
      error: e
    });
  }
};
